import React from 'react'
import {
  Segment,
  Container,
  Header,
  Button,
  Icon,
  Grid,
  Divider,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import logo from './cc.svg'

const Home = ({onSelect}) => (
  <Segment basic textAlign='center'>
    <Container text style={{ marginTop: '4em' }}>
      <img src={logo} alt='Computing Curriculum logo' height='100px' style={{display: 'block', margin: 'auto'}}/>
      <Header as='h1' textAlign='center' style={{
          marginTop: '0.5em',
        }}>
        Computing Curriculum
      </Header>
      <Header as='h2' textAlign='center' style={{
          fontSize: '1em',
          fontWeight: 'normal',
          marginTop: '1.5em',
          marginBottom: '1.5em',
        }}>
        Explore and map the IEEE/ACM Computer Science curriculum (CS2013).
      </Header>
      <Segment placeholder>
        <Grid columns={2} stackable textAlign='center'>
          <Divider vertical>Or</Divider>
          <Grid.Row verticalAlign='middle'>
            <Grid.Column>
              <Header icon>
                <Icon name='eye' />
                Explore Curriculum
              </Header>
              <p>
                Browse and search knowledge areas &amp; units, topics, and learning outcomes.
              </p>
              <Button color='blue' as={Link} to='/areas'>Explore</Button>
            </Grid.Column>
            <Grid.Column>
              <Header icon>
                <Icon name='check' />
                Select Subset
              </Header>
              <p>
                Map your course or curriculum to topics and learning outcomes.
              </p>
              <Button color='orange' onClick={onSelect} as={Link} to='/selections'>Select</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
      <Header as='h2' style={{marginTop: '3em'}}>Who is this good for?</Header>
      <Segment basic style={{marginTop: '3em'}}>
        <Grid columns={3} divided inverted stackable>
          <Grid.Column>
            <Header as='h3' content='Practicing Instructors'/>
            <p>
              Discover whether your course is missing relevant topics
              or learning outcomes.
            </p>
          </Grid.Column>
          <Grid.Column>
            <Header as='h3' content='Curriculum Developers'/>
            <p>
              Map courses to topics and learning outcomes
              to discover overlap and gaps.
            </p>
          </Grid.Column>
          <Grid.Column>
            <Header as='h3' content='Instructors in Training'/>
            <p>
              Get the big picture of the body of knowledge
              that makes up computer science.
            </p>
          </Grid.Column>
        </Grid>
      </Segment>
    </Container>
  </Segment>
)

export default Home